export const SENTRY_DSN: string | undefined = import.meta.env.VITE_SENTRY_DSN;

export const NPT_API_URL: string | undefined = import.meta.env.VITE_NPT_API_URL;

export const FRIENDLY_CAPTCHA_SITE_KEY: string | undefined = import.meta.env
  .VITE_FRIENDLY_CAPTCHA_SITE_KEY;

export const enum QueryKeys {
  ME = 'me',
  ARTWORKS = 'artworks',
  ORDERS = 'orders',
  ORDERS_SEARCH = 'orders-search',
  VENUES = 'venues',
  VENUE_DECORATIONS = 'venue-decorations',
}
